import React from 'react';
import { TrendingUp } from 'lucide-react';

export const Badge = ({ status }) => {
  const s = {
    active: 'bg-emerald-100 text-emerald-700', low_stock: 'bg-amber-100 text-amber-700',
    out_of_stock: 'bg-red-100 text-red-700', shipped: 'bg-blue-100 text-blue-700',
    processing: 'bg-yellow-100 text-yellow-700', packed: 'bg-indigo-100 text-indigo-700',
    in_transit: 'bg-cyan-100 text-cyan-700', delivered: 'bg-emerald-100 text-emerald-700',
    cancelled: 'bg-red-100 text-red-700', returned: 'bg-gray-100 text-gray-700',
    refunded: 'bg-orange-100 text-orange-700', paid: 'bg-emerald-100 text-emerald-700',
    admin: 'bg-purple-100 text-purple-700', manager: 'bg-blue-100 text-blue-700',
    staff: 'bg-gray-100 text-gray-700', pending: 'bg-yellow-100 text-yellow-700',
    approved: 'bg-emerald-100 text-emerald-700', rejected: 'bg-red-100 text-red-700',
    create: 'bg-emerald-100 text-emerald-700', delete: 'bg-red-100 text-red-700',
    update: 'bg-blue-100 text-blue-700', received: 'bg-emerald-100 text-emerald-700',
    sold: 'bg-purple-100 text-purple-700', urgent: 'bg-red-100 text-red-700',
    warning: 'bg-amber-100 text-amber-700', info: 'bg-blue-100 text-blue-700',
  };
  return (
    <span className={`text-xs px-2 py-0.5 rounded-full font-medium capitalize ${s[status] || 'bg-gray-100 text-gray-600'}`}>
      {(status || '').replace('_', ' ')}
    </span>
  );
};

export const MktBadge = ({ m }) => {
  const s = {
    shopee:       'bg-orange-100 text-orange-700',
    carousell:    'bg-red-100 text-red-700',
    ebay:         'bg-blue-100 text-blue-700',
    shopify:      'bg-green-100 text-green-700',
    woocommerce:  'bg-purple-100 text-purple-700',
    woocomerce:   'bg-purple-100 text-purple-700',
  };
  return <span className={`text-xs px-2 py-0.5 rounded-full capitalize ${s[m] || 'bg-gray-100 text-gray-600'}`}>{m}</span>;
};

export const Th = ({ children }) => (
  <th className="text-left px-4 py-3 text-xs text-gray-500 font-medium uppercase tracking-wider">{children}</th>
);

export const Td = ({ children, className = '' }) => (
  <td className={`px-4 py-3 text-sm ${className}`}>{children}</td>
);

/** Format a date string in the configured timezone. */
export const formatDT = (dateStr, tz = 'Asia/Singapore') => {
  if (!dateStr) return '—';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return String(dateStr).slice(0, 16);
    const label = d.toLocaleString('en-SG', {
      timeZone: tz,
      day: 'numeric', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
    // Append timezone abbreviation
    const abbr = new Intl.DateTimeFormat('en-SG', { timeZone: tz, timeZoneName: 'short' })
      .formatToParts(d).find(p => p.type === 'timeZoneName')?.value || '';
    return `${label} ${abbr}`;
  } catch {
    return String(dateStr).slice(0, 16);
  }
};


export const HelpTip = ({ text }) => {
  const [v, setV] = React.useState(false);
  return (
    <span className="relative inline-flex items-center ml-1.5 shrink-0">
      <button
        onMouseEnter={() => setV(true)}
        onMouseLeave={() => setV(false)}
        className="w-4 h-4 rounded-full bg-gray-200 text-gray-500 text-[9px] font-bold hover:bg-blue-100 hover:text-blue-600 transition-colors flex items-center justify-center"
      >?</button>
      {v && (
        <div className="absolute left-5 top-0 z-[100] w-64 bg-gray-900 text-white text-xs rounded-xl p-3 shadow-2xl leading-relaxed pointer-events-none">
          {text}
        </div>
      )}
    </span>
  );
};

export const StatCard = ({ label, value, icon: Icon, color, sub, sub2 }) => (
  <div className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
    <div className="flex items-center justify-between mb-3">
      <span className="text-sm text-gray-500">{label}</span>
      <div className={`w-9 h-9 rounded-lg bg-${color}-50 flex items-center justify-center`}>
        <Icon className={`w-5 h-5 text-${color}-500`} />
      </div>
    </div>
    <p className="text-2xl font-bold text-gray-900">{value ?? 0}</p>
    {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    {sub2 && (
      <p className="text-xs text-emerald-600 mt-0.5 flex items-center gap-1">
        <TrendingUp className="w-3 h-3" />{sub2}
      </p>
    )}
  </div>
);
